import React from "react";
import { LogoMark } from "@/components/Logo";
import { useSite } from "@/context/SiteContext";
import { ADDRESS } from "@/i18n/translations";

const scrollTo = (id) => document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });

const Footer = () => {
  const { t } = useSite();
  const links = [
    { id: "about", label: t.nav.about },
    { id: "services", label: t.nav.services },
    { id: "why", label: t.nav.why },
    { id: "process", label: t.nav.process },
    { id: "gallery", label: t.nav.gallery },
    { id: "contact", label: t.nav.contact },
  ];

  return (
    <footer data-testid="footer" className="border-t border-border bg-background">
      <div className="mx-auto grid max-w-[1400px] grid-cols-1 gap-12 px-6 py-16 lg:grid-cols-12 lg:px-12">
        <div className="lg:col-span-5">
          <div className="flex items-center gap-3 text-gold">
            <LogoMark size={30} />
            <span className="font-heading text-2xl font-medium tracking-tight text-foreground">
              MAHAKAIN
            </span>
          </div>
          <p className="mt-5 max-w-sm font-heading text-xl font-light italic text-muted-foreground">
            {t.footer.tagline}
          </p>
        </div>

        <div className="lg:col-span-3">
          <h4 className="font-body text-xs font-medium uppercase tracking-luxe text-gold">
            {t.footer.nav}
          </h4>
          <ul className="mt-5 space-y-3">
            {links.map((l) => (
              <li key={l.id}>
                <button
                  data-testid={`footer-nav-${l.id}`}
                  onClick={() => scrollTo(l.id)}
                  className="font-body text-sm font-light text-muted-foreground transition-colors hover:text-gold"
                >
                  {l.label}
                </button>
              </li>
            ))}
          </ul>
        </div>

        <div className="lg:col-span-4">
          <h4 className="font-body text-xs font-medium uppercase tracking-luxe text-gold">
            {t.footer.company}
          </h4>
          <p className="mt-5 font-body text-sm font-light leading-relaxed text-muted-foreground">
            PT MAHAKAIN SUTERA NIRMALA
          </p>
          <p className="mt-3 font-body text-sm font-light leading-relaxed text-muted-foreground">
            {ADDRESS}
          </p>
        </div>
      </div>

      <div className="border-t border-border">
        <div className="mx-auto flex max-w-[1400px] flex-col items-center justify-between gap-3 px-6 py-6 sm:flex-row lg:px-12">
          <p className="font-body text-xs text-muted-foreground">
            © {new Date().getFullYear()} PT MAHAKAIN SUTERA NIRMALA. {t.footer.rights}
          </p>
          <p className="font-mono text-xs uppercase tracking-[0.12em] text-muted-foreground">
            Jakarta · Indonesia
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
